/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import {
  GetNewsListRequest, GetNewsRequest, NewsItem, NewsState,
} from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, defaultRequestConfig, getApiRequestConfig } from '../../config/network';
import { ConfigurationAPI } from '../../plugins/configuration/types/configuration';

export const actions: ActionTree<NewsState, RootState> = {
  fetchNewsList({ commit }, payload: GetNewsListRequest): Promise<NewsItem[]> {
    commit('newsListLoading');

    return new Promise((resolve, reject) => {
      this.state.$http(`news/${payload.offset}/${payload.limit}`, getApiRequestConfig(ApiEndpointEnum.News))
        .then((response: AxiosResponse<Array<NewsItem>>) => {
          const newsListLoaded: Array<NewsItem> = response && response.data;
          commit('newsListLoaded', newsListLoaded);
          resolve(newsListLoaded);
        }, (error) => {
          commit('newsListError', { code: error.response.status, message: error.response.statusText, data: error.response.data });
          reject(error);
        });
    });
  },
  getNewsFromDOM({ commit }, dom: ConfigurationAPI): Promise<NewsItem> {
    commit('newsLoading');

    return new Promise((resolve, reject) => {
      // --- since we cannot rely on http response codes
      // --- we have to use custom type guards to check if the page data is correct
      if (dom.pageData !== undefined && (dom.pageData as NewsItem).content !== undefined) {
        commit('newsLoaded', (dom.pageData as NewsItem));
        resolve((dom.pageData as NewsItem));
      } else {
        // --- no page data, 404 error
        commit('newsError', { code: 404, message: null, data: dom.pageData });
        reject();
      }
    });
  },
  fetchNews({ commit }, payload: GetNewsRequest): Promise<NewsItem> {
    commit('newsLoading');

    return new Promise((resolve, reject) => {
      this.state.$http(window.location.href.concat('.json'), defaultRequestConfig)
        .then((response: AxiosResponse<NewsItem>) => {
          const newsItems: NewsItem = response && response.data;
          commit('newsLoaded', newsItems);
          resolve(newsItems);
        }, (error) => {
          commit('newsError', { code: error.response.status, message: error.response.statusText, data: error.response.data });
          reject(error);
        });
    });
  },
};
